import { render, staticRenderFns } from "./ReportDistinguish.vue?vue&type=template&id=0b6407a3&scoped=true&"
import script from "./ReportDistinguish.vue?vue&type=script&lang=js&"
export * from "./ReportDistinguish.vue?vue&type=script&lang=js&"
import style0 from "./ReportDistinguish.vue?vue&type=style&index=0&id=0b6407a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6407a3",
  null
  
)

export default component.exports